/**
 * @generated SignedSource<<73dafbef1abfc5aceb23a4bc9cd1a735>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetVideoTitleVideo$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersGetVideoTitleVideo";
};
export type helpersGetVideoTitleVideo$key = {
  readonly " $data"?: helpersGetVideoTitleVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetVideoTitleVideo">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetVideoTitleVideo"
};

(node as any).hash = "27368e5a2569ccfc2843e0e14e987c24";

export default node;
